import { Card, Divider } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ReactTimeAgo from "react-time-ago";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Home.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import Button from "../../Subcomponents/Button";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import AllotmentprofileIcon from "../../Assets/Images/Common/AllotmentProfile.svg";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import AllotmentInfoIcon from "../../Assets/Images/Common/info-circle.svg";
import SDRPayment from "../../Modals/SDRPayment/SDRPayment";
import { createPaymentOrder } from "../../Services/Allotment";
import { dismissLoader, presentLoader } from "../../Services/loader";
import CancelUnit from "../../Modals/CancelUnit.js/CancelUnit";
import AllotmentDetails from "../AllotmentDetails/AllotmentDetails";
import { Tooltip } from "react-tooltip";
import { errorTost } from "../../Services/Toast";
import AgreementKYC from "../../Modals/AgreementKYC/AgreementKYC";
import VirtualAccount from "../../Modals/VirtualAccountDetails/VirtualAccount";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import UnitCost from "../../Modals/UnitCost/UnitCost";
import PaymentGatewaySelection from "../../Modals/PaymentGateway/PaymentGatewaySelection";

const BalanceSDR = ({ allotment, SdrPaymentMode }) => {
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const [openSdrModal, setOpenSdrModal] = useState(false);
	const [allotmentDetails, setAllotmentDetails] = useState({});
	const [openCancelUnitModal, setOpenCancelUnitModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [openAgreementKYCModal, setOpenAgreementKYCModal] = useState(false);
	const [showVertualAccount, setShowVertualAccount] = useState(false);
	const [showUnitCost, setShowUnitCost] = useState(false);
	const [openPaymentGatewaySelectionModal, setOpenPaymentGatewaySelectionModal] = useState(false);
	const [sdrAmount, setSdrAmount] = useState(0);

	function returnRes(value) {
		if (value && value > 0) {
			setSdrAmount(value);
			console.log("returnRes 1 called ..........: ", value);
			setOpenPaymentGatewaySelectionModal(true);
			setOpenSdrModal(false);
			// return; // TEMPORARY RETURN
			// handleSDRPayment(value);
			// setOpenSdrModal(false);
		}
	}
	
	async function handleSDRPayment(sdrAmount) {
		presentLoader();
		const obj = {
			amount: sdrAmount,
			type: "SDR",
			transactionObj: {
				amount: sdrAmount,
				transactionType: allotmentDetails.pricingType,
				modeOfPayment: "Razorpay-Customer Portal",
				allotmentPaymentId: allotmentDetails.allotmentPaymentId,
				unitId: allotmentDetails?.unitId?.unitId,
				inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId,
				leadId: allotmentDetails.leadId.leadId,
				status: "pending",
			},
		};
		await createPaymentOrder(obj)
			.then(async (order) => {
				if (order?.data?.success) {
					dismissLoader();
					const options = {
						key: process.env.REACT_APP_RAZOR_PAY_KEY, // Enter the Key ID generated from the Dashboard
						amount: sdrAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
						currency: "INR",
						name: "VJ Developers",
						// image: "../../Assets/Images/SideMenu/vjLogo.jpg",
						description: "Payment for allotment " + allotmentDetails?.allotmentPaymentId,
						order_id: order.data.id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
						handler: function (response) {
							console.log("response: ", response);
						},
					};

					const rzp1 = new window.Razorpay(options);

					rzp1.on("payment.failed", function (response) {
						console.log("fail response: ", response);
						// ?todo: show loader modal
					});

					rzp1.open();
				} else {
					dismissLoader();
					errorTost("Couldn't create order! please try again later");
				}
			})
			.catch((err) => {
				console.log("err: ", err);
				dismissLoader();
				errorTost("Network Erro. Please try again later!r");
			});
	}

	return (
		<>
			<Card className={cssClasses.allotmentEventWrap} style={{ borderRadius: "20px", boxShadow: "none" }}>
				<div className={cssClasses.allotmentCardHeader}>
					<div className={cssClasses.allotmentTokenNumWrap}>
						<div className={cssClasses.allotmentImg}>
							<img src={AllotmentBuildingIcon} alt="allotment" />
						</div>
						<div className={cssClasses.allotmentProjectDetail}>
							<div className={cssClasses.allotmentProjectDetailFirst}>
								<span>
									{allotment?.unitId && (
										<span>
											{allotment?.unitId.wingId.displayName
												? allotment?.unitId.wingId.displayName
												: allotment?.unitId.wingId.wingName}{" "}
											- {allotment?.unitId.unitNo}
										</span>
									)}
									{allotment?.inventoryMergedId &&
										((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
											allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
												<span>
													{allotment?.inventoryMergedId.unit1Id.wingId.displayName
														? allotment?.inventoryMergedId.unit1Id.wingId.displayName
														: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit1Id.unitNo} & {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
												</span>
											)) ||
											(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
												allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
													<span>
														{allotment?.inventoryMergedId.unit1Id.wingId.displayName
															? allotment?.inventoryMergedId.unit1Id.wingId.displayName
															: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
														{allotment?.inventoryMergedId.unit2Id.wingId.displayName
															? allotment?.inventoryMergedId.unit2Id.wingId.displayName
															: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
													</span>
												)))}
								</span>
								{allotment.paymentId?.eventTokenId?.tokenId.isPreselect && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											style={{
												color: "#FF7B01",
												border: "1px solid #FFC997",
												borderRadius: "0px",
											}}
										></LeadStatusChip>
									</span>
								)}
							</div>
							<div className={cssClasses.allotmentProjectName}>
								{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
								{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
							</div>
							{/* {allotment.paymentId?.eventTokenId?.tokenId.isPreselect && (
                <span>
                  <LeadStatusChip
                    label={"Preselect"}
                    style={{
                      color: "#FF7B01",
                      border: "1px solid #FFC997",
                      borderRadius: "0px",
                    }}
                  ></LeadStatusChip>
                </span>
              )} */}
						</div>
					</div>
					<div className={cssClasses.allotmenttimeActionSection}>
						<div className={cssClasses.allotmentTokenLastUpdate}>
							<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={allotment?.last_updated_at ?? allotment?.created_at} locale="en-US" />
						</div>
						<div className={cssClasses.tokenActions}>
							<ThreeDotsMenu
								list={allotment.menuOpt}
								selectedValue={(e) => {
									if (e === "View Details") {
										setAllotmentDetails(allotment);
										setShowDetails(true);
										// setScheduleSiteVisitModal(true);
									} else if (e === "Cancel Unit") {
										setOpenCancelUnitModal(true);
										setAllotmentDetails(allotment);
									}
								}}
							/>
						</div>
					</div>
				</div>
				<div
					style={{
						width: "100%",
					}}
				>
					<div className={cssClasses.tokenStatus}>
						{allotment.status === "Payment Complete" || allotment.status === "Agreement Done" ? (
							<>
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Cancelled" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{/* ? if 5,00,000 amount is paid; check for SDR amount */}
								{/* {allotment.paidAmount >= allotment?.bookingAmt.total &&
								allotment?.unitCost.sdr - allotment?.bookingAmt.sdr - (allotment?.paidAmount - allotment?.bookingAmt.total) > 0 ? ( */}
								{allotment.unitCost?.sdr - allotment.paidAmt?.sdr > 0 ? (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								) : (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#027A48",
											backgroundColor: "#ECFDF3",
										}}
									></LeadStatusChip>
								)}
								{!allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						) : (
							<>
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "cancelled" ||
									allotment.status === "Cancelled" ||
									allotment.status === "Cancellation Rejected" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Partial Payment Done" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "Payment Pending" && (
									<LeadStatusChip
										label={"Payment Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "expired" && (
									<LeadStatusChip
										label={"Expired"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "On Hold" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#3538CD",
											backgroundColor: "#EEF4FF",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Released" ||
									allotment.status === "Refund Processed" ||
									allotment.status === "Refund Initiated") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "rgb(180, 35, 24)",
												backgroundColor: "rgb(254, 243, 242)",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Partial Payment Done" && !allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						)}
						{allotment?.leadId?.LeadsReferral.length > 0 && allotment?.leadId?.LeadsReferral[0]?.id &&
							<LeadStatusChip
								label="VJOP"
								style={{
									color: "rgb(180, 35, 24)",
									backgroundColor: "rgb(254, 243, 242)",
								}}
							></LeadStatusChip>
						}
					</div>
				</div>
				<div className={cssClasses.allotmentCpDetails}>
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>VJ Sales Manager : </div>
								<div>{loggedInUser?.userId?.name ?? "NA"}</div>
							</div>
						</div>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>FOS : </div>
								<div>{loggedInUser?.fosId?.name ?? "NA"}</div>
							</div>
						</div>
					</div>
					<Divider orientation="vertical" variant="middle" flexItem />
					{/* <Divider orientation="vertical" variant="middle" flexItem /> */}
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>Channel Partner : </div>
								<div>{loggedInUser?.cpId?.billingName ?? "NA"}</div>
							</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentCardData}>
					<div className={cssClasses.allotmentCardDetails}>
						<div className={cssClasses.allotmentEventData}>
							<div className={cssClasses.allotmentTokenData}>
								<span className={cssClasses.AllotmentEventName}>{allotment.paymentId?.eventTokenId?.eventId?.title}</span>
							</div>
							<div className={cssClasses.allotmentUnitDetails}>
								{allotment?.unitId?.inventoryTypeId?.type &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Inventory Type") ? (
									<span>{allotment?.unitId?.inventoryTypeId?.type} • </span>
								) : (
									""
								)}
								{allotment?.unitId?.displayUnitType &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Display Unit Type") ? (
									<span>{allotment?.unitId?.displayUnitType} • </span>
								) : (
									""
								)}
								{/* } */}
								{allotment.inventoryMergedId && (
									<>
										{/* {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type === allotment.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                    <span>{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
                                                }
                                                {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type !== allotment.inventoryMergedId.unit2Id.inventoryTypeId.type && */}
										<span>
											{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
											{allotment.inventoryMergedId.unit2Id.inventoryTypeId.type}
										</span>
										{/* } */}
									</>
								)}

								{allotment.unitId && <span>{allotment.unitId.floorNo}</span>}
								<span>{" • "}</span>
								{allotment.unitId && (
									// <span>Area {allotment.unitId.chargeableArea} sq.ft</span>
									<span>Area {allotment.unitId.saleableArea} sq.ft</span>
								)}
								{allotment.inventoryMergedId && (
									<>
										{allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>{allotment.inventoryMergedId.unit1Id.floorNo}</span>
										)}
										{allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>
												{allotment.inventoryMergedId.unit1Id.floorNo} - {allotment.inventoryMergedId.unit2Id.floorNo}
											</span>
										)}
									</>
								)}
								{allotment.inventoryMergedId && (
									<>
										<span>
											Area {allotment.inventoryMergedId.unit1Id.saleableArea} +{" "}
											{allotment.inventoryMergedId.unit2Id.saleableArea} sq.ft
										</span>
									</>
								)}
							</div>
						</div>
						<div className={cssClasses.allotmentDateContent}>
							<div className={cssClasses.allotmentDateData}>
								<img src={AllotmentCalenderIcon} alt="Calender-check" />
								Alloted On:{" "}
							</div>
							<div className={cssClasses.allotmentDate}>
								{new Date(allotment.created_at).toDateString()},{" "}
								{new Date(allotment.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmentPriceBreakDown}>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Total SDR :
								<img data-tooltip-id="sdr" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="sdr" content="Total Stamp Duty Registration" />
							</div>
							<div>₹ {numberWithCommas(allotment.unitCost?.sdr)}</div>
						</div>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Paid SDR :
								<img data-tooltip-id="psdr" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="psdr" content="Pending Stamp Duty Registration" />
							</div>
							<div>₹{numberWithCommas(allotment?.paidAmt?.sdr)}</div>
						</div>
						<Divider orientation="vertical" flexItem style={{ borderWidth: "1px" }} />
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentTotalAmount}>
								Pending SDR:
								<img data-tooltip-id="sdr-amt" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="sdr-amt" content="SDR Amount" />
							</div>
							<div className={cssClasses.allotmentTotalAmount}>
								<span>
									₹
									{numberWithCommas(
										allotment.unitCost?.sdr - allotment?.paidAmt?.sdr < 0 ? 0 : allotment.unitCost?.sdr - allotment?.paidAmt?.sdr
									)}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentActionBtnWrap}>
					<div className={cssClasses.allotmentBtnView}>
						<Button
							btnName={"View Unit Cost"}
							clicked={() => setShowUnitCost(true)}
							style={{
								color: "#344054",
								backgroundColor: "#FFFFFF",
								fontSize: "1.4rem",
								lineHeight: "2rem",
								fontFamily: "Inter-Medium !important",
							}}
						></Button>
					</div>
					{SdrPaymentMode === true ? (
						<>
							{allotment.status === "Payment Complete" &&
								allotment?.kycFormFilled &&
								allotment?.unitCost?.sdr - allotment?.paidAmt?.sdr > 0 && (
									<div className={cssClasses.paidAmt}>
										<Button
											btnName={"Pay Balance SDR"}
											// ! condition for Pay SDR
											clicked={() => {
												setAllotmentDetails(allotment);
												// handleSDRPayment(allotment);
												setOpenSdrModal(true);
											}}
											style={{
												color: "#fff",
												backgroundColor: "rgb(21, 112, 239)",
												fontSize: "1.4rem",
												lineHeight: "2rem",
												fontFamily: "Inter-Medium !important",
											}}
										></Button>
									</div>
								)}
						</>
					) : (
						SdrPaymentMode === false && (
							<div className={cssClasses.paidAmt}>
								<Button
									disable={allotment?.unitCost?.sdr - allotment?.paidAmt?.sdr < 0}
									btnName={"View Virtual Account Details"}
									// ! condition for Pay SDR
									clicked={() => {
										setShowVertualAccount(true);
									}}
									style={{
										color: "#fff",
										backgroundColor: "rgb(21, 112, 239)",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
									}}
								></Button>
							</div>
						)
					)}
					{!allotment.isAgreementFormFilled ? (
						<div className={cssClasses.paidAmt}>
							<Button
								disable={allotment.status === "Released" || allotment.status === "Cancelled" || allotment?.status?.includes("Refund")}
								btnName="Fill Agreement confirmation form"
								clicked={() => {
									setOpenAgreementKYCModal(true);
								}}
								style={{
									color: "#fff",
									backgroundColor: "rgb(21, 112, 239)",
									fontSize: "1.4rem",
									lineHeight: "2rem",
									fontFamily: "Inter-Medium !important",
								}}
							/>
						</div>
					) : (
						<div className={cssClasses.paidAmt}>
							<Button
								disable={
									allotment?.CRM[0]?.sentForAgreement ||
									allotment?.CRM[0]?.skipCreateDraft ||
									allotment.status === "Released" ||
									allotment.status === "Cancelled" ||
									allotment?.status?.includes("Refund")
								}
								btnName="Edit Agreement confirmation form"
								clicked={() => {
									setOpenAgreementKYCModal(true);
								}}
								style={{
									color: "#fff",
									backgroundColor: "rgb(21, 112, 239)",
									fontSize: "1.4rem",
									lineHeight: "2rem",
									fontFamily: "Inter-Medium !important",
								}}
							/>
						</div>
					)}
				</div>
			</Card>
			{openSdrModal && (
				<SDRPayment
					open={openSdrModal}
					handleClose={() => {
						setOpenSdrModal(false);
					}}
					allotmentDetails={allotmentDetails}
					returnRes={returnRes}
				/>
			)}
			{openPaymentGatewaySelectionModal && (
				<PaymentGatewaySelection
					open={openPaymentGatewaySelectionModal}
					onClose={() => {
						setOpenPaymentGatewaySelectionModal(false);
					}}
					allotmentDetails={allotmentDetails}
					handleSDRPayment={handleSDRPayment}
					sdrAmount={sdrAmount}
					type={"sdr"}
				/>
			)}
			{showDetails && (
				<AllotmentDetails
					open={showDetails}
					handleClose={() => {
						setAllotmentDetails({});
						setShowDetails(false);
					}}
					data={allotmentDetails}
				/>
			)}
			{openCancelUnitModal && (
				<CancelUnit
					open={openCancelUnitModal}
					handleClose={() => {
						setOpenCancelUnitModal(false);
					}}
					allotmentDetails={allotmentDetails}
				/>
			)}
			{openAgreementKYCModal && (
				<AgreementKYC
					allotment={allotment}
					open={openAgreementKYCModal}
					handleClose={() => {
						setOpenAgreementKYCModal(false);
					}}
					edit={allotment.isAgreementFormFilled}
				/>
			)}
			{showVertualAccount && (
				<VirtualAccount
					loggedInUser={loggedInUser}
					open={showVertualAccount}
					handleClose={() => {
						setShowVertualAccount(false);
					}}
				/>
			)}
			{showUnitCost && (
				<UnitCost
					allotment={allotment}
					open={showUnitCost}
					handleClose={() => {
						setShowUnitCost(false);
					}}
				/>
			)}
		</>
	);
};

export default BalanceSDR;
